import { confirmable, createConfirmation } from 'react-confirm';
import { AlertDialog } from './AlertDialog.js';
import { ConfirmDialog } from './ConfirmDialog.js';
import { PromptDialog } from './PromptDialog.js';
export const alert = createConfirmation(confirmable(AlertDialog));
export const confirm = createConfirmation(confirmable(ConfirmDialog));
export const prompt = createConfirmation(confirmable(PromptDialog));
export const Alert = alert;
export const Confirm = confirm;
export const Prompt = prompt;
//# sourceMappingURL=index.js.map